export default __webpack_public_path__ + "static/media/mojaco_thanks.b85760a1.png";